import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

const ABOUT_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/iarhbyoq_50835821-667d-44f9-822e-fb4c11aebdc9.png";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:max-w-[1280px] lg:mx-auto grid grid-cols-1 gap-[43px] sm:gap-12 lg:grid-cols-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
        className="order-2 sm:order-none lg:col-span-5 relative"
      >
        <div className="relative h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]">
          <img src={ABOUT_IMAGE} alt="Engineer reviewing controls inside an energy facility" className="w-full h-full object-cover" />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
        className="order-1 sm:order-none lg:col-span-7"
      >
        <h2 className="mb-[23px] font-heading text-[30px] font-semibold leading-tight text-ink sm:mb-6 sm:text-[35px] lg:text-[41px]">
          <span className="sm:hidden">
            Led by engineers,
            <br />
            not marketers
          </span>
          <span className="hidden sm:inline">Led by engineers, not marketers</span>
        </h2>
        <p className="text-[15px] text-inkSoft leading-relaxed mb-5">
          Off-Grid Hydrogen is led by Jun Zhu, whose 30-plus years spans mechanical engineering,
          manufacturing, R&amp;D, and executive management across industrial integration businesses in China
          and North America — supplier qualification, technical governance, procurement, and project execution
          at scale.
        </p>
        <p className="text-[15px] text-inkSoft leading-relaxed mb-8">
          Projects requiring professional engineering will be delivered with a licensed British
          <br className="hidden lg:block" /> Columbia Professional Engineer (P.Eng.) / EGBC Responsible Registrant and qualified technology
          partners.
        </p>
        <div className="inline-flex items-center gap-3 bg-white rounded-2xl py-5 px-6 border border-borderLight lg:whitespace-nowrap" data-testid="about-credibility-note">
          <ShieldCheck className="text-teal shrink-0" size={20} />
          <p className="text-sm text-inkSoft leading-relaxed">
            One team. From assessment
            <br className="lg:hidden" /> to long-term O&amp;M.
          </p>
        </div>
        <Link
          to="/about"
          data-testid="about-cta"
          className="group mt-7 flex w-fit items-center gap-1.5 text-sm font-medium text-teal hover:text-tealHover transition-colors duration-300"
        >
          About Off-Grid Hydrogen
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </Link>
      </motion.div>
    </div>
  </section>
);
